import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { withRouter } from '../../router-compat';
import { User } from 'react-feather';
import styled from 'styled-components';

import { Colors, Metrics } from '../../theme';
import { media } from '../../utils';
import Bank from '../../assets/svg/icons/bank.svg';
import Store from '../../assets/svg/icons/store.svg';
import Wallet from '../../assets/svg/icons/wallet.svg';
import Deposit from '../../assets/svg/icons/deposit.svg';
import Step from './step';

const background = Colors.lighten(Colors.brand.primary, 35);

const Container = styled.div`
  background-color: ${background};
  box-shadow: ${Colors.shadows.primary};
  position: relative;
`;

const Content = styled.div`
  margin: auto;
  max-width: ${Metrics.maxWidth}px;
  padding: 1.5em 2em;
  width: 100%;
`;

const Steps = styled.div`
  display: flex;
`;

const IncompleteAccount = ({ history, incompleteAccount, organizationId, uiStore }) => {
  const { t } = useTranslation('translations');
  const goTo = section => () => {
    const { id } = incompleteAccount.app.organization;

    uiStore.selectedMenuItem = section;
    history.push(`/organization/${id}/${section}`);
  };

  useEffect(() => {
    incompleteAccount.hasCharges = true;
    incompleteAccount.hasPayoutInfo = true;
    incompleteAccount.client.service('organizations').on('patched', incompleteAccount.checkOrganization);
    incompleteAccount.client.service('charges').on('created', incompleteAccount.onChargeCreated);
    incompleteAccount.client.service('payout-information').on('created', incompleteAccount.onPayoutInformationCreated);
    incompleteAccount.checkStatus();

    return () => {
      incompleteAccount.client.service('organizations').off('patched', incompleteAccount.checkOrganization);
      incompleteAccount.client.service('charges').off('created', incompleteAccount.onChargeCreated);
      incompleteAccount.client.service('payout-information').off('created', incompleteAccount.onPayoutInformationCreated);
    };
  }, [organizationId]);

  if (!incompleteAccount.app.organization || media.mobile) return null;

  if (incompleteAccount.hasCharges && incompleteAccount.hasCurrencies && incompleteAccount.hasPayoutInfo && incompleteAccount.hasValidOrganization && incompleteAccount.isApproved) {
    return null;
  }

  return (
    <Container>
      <Content>
        <Steps>
          <Step
            actionLabel={t('incompleteAccount.fix')}
            description={t('incompleteAccount.businessInfoDescription')}
            icon={<Bank />}
            isActive={incompleteAccount.isStepActive(0)}
            isComplete={incompleteAccount.isStepComplete(0)}
            title={t('incompleteAccount.businessInfo')}
            onClick={goTo('settings_business')} />
          <Step
            actionLabel={t('incompleteAccount.fix')}
            description={t('incompleteAccount.currenciesDescription')}
            icon={<Deposit />}
            isActive={incompleteAccount.isStepActive(1)}
            isComplete={incompleteAccount.isStepComplete(1)}
            title={t('incompleteAccount.currencies')}
            onClick={goTo('settings_currencies')} />
          <Step
            actionLabel={t('incompleteAccount.fix')}
            description={t('incompleteAccount.payoutsDescription')}
            icon={<Wallet />}
            isActive={incompleteAccount.isStepActive(2)}
            isComplete={incompleteAccount.isStepComplete(2)}
            title={t('incompleteAccount.payouts')}
            onClick={goTo('settings_payouts')} />
          <Step
            actionLabel={t('incompleteAccount.fix')}
            description={t('incompleteAccount.approvalDescription')}
            icon={<User />}
            isActive={incompleteAccount.isStepActive(3)}
            isComplete={incompleteAccount.isStepComplete(3)}
            title={t('incompleteAccount.approval')} />
          <Step
            actionLabel={t('incompleteAccount.fix')}
            description={t('incompleteAccount.paymentsDescription')}
            icon={<Store />}
            isActive={incompleteAccount.isStepActive(4)}
            isComplete={incompleteAccount.isStepComplete(4)}
            title={t('incompleteAccount.payments')}
            onClick={goTo('developers_api-keys')} />
        </Steps>
      </Content>
    </Container>
  );
};

export default inject('incompleteAccount', 'uiStore')(withRouter(observer(IncompleteAccount)));
